// extracted by css-extract-rspack-plugin
export default {"form":"hrKVdta8uATXkdjs","fieldLabel":"NxeX2B11iPMXi_ZC","btnFile":"v5htlkfCKYclU8fo","uploadIcon":"qh6eakMCctA_Q6ny","submitRow":"rQl9msolCIWp2DIA"};